import React from 'react'
import { RuleVariant, RuleOrientation } from './Rule.type'

export type RuleProps = {
  variant?: RuleVariant
  orientation?: RuleOrientation
  className?: string
  ariaHidden?: boolean
  testId?: string
}

export const Rule = (props: RuleProps) => {
  const {
    variant = 'medium',
    orientation = 'horizontal',
    className,
    ariaHidden = false,
    testId
  } = props

  const classList = ['']

  switch (variant) {
    case RuleVariant.THIN:
      classList.push('Rule Rule--thin')
      break
    case RuleVariant.MEDIUM:
      classList.push('Rule')
      break
    case RuleVariant.THICK:
      classList.push('Rule Rule--thick')
      break
    default:
      classList.push('Rule')
      break
  }

  if (className) {
    classList.push(className)
  }
  return (
    <hr
      className={`${classList.join(' ')} ${orientation === RuleOrientation.VERTICAL ? 'Rule--vertical' : ''}`}
      aria-hidden={ariaHidden}
      data-testid={testId ? `${testId}-rule` : null}
    />
  )
}
